import { Component, EventEmitter, OnInit, Output, HostListener } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription, filter, map, mergeMap } from 'rxjs';
import { AuthService } from 'src/app/features/services/auth/auth.service';
import { DataAccessService } from '../../../services/data-access.service';
import { ToolsService } from '../../../services/tools.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggingService } from 'src/app/shared/services/Logging.service';

@Component({
  selector: 'app-editing-text',
  templateUrl: './editing-text.component.html',
  styleUrls: ['./editing-text.component.scss'],
  inputs:['textLen','textMaxLen','showParameter','showem' ,'pickparams', 'pickparamsprofile','pickparamsvariants',
          'pickparamsURL','showLength', 'idBOT' , 'orderpickparamsprofile','pickparamsemailnotifications',
          'pickparamsOrderevents','pickparamsemailnotificationsCancelOrder' , 'showPersonolization' , 'showPersonolizationGreetingfb', 'showPersonolizationfB']
})
export class EditingTextComponent implements OnInit {
  pageInfo;
  idBOT: any; 
  subUser : any;
  user;
  bot;
  pickparamsemailnotifications
  pickparamsemailnotificationsCancelOrder
  pickparamsOrderevents
  docBot!: Subscription;
  showsize=false;
  textLen;
  textMaxLen;
  showParameter! : boolean;
  showLength! : boolean;
  pickparams;
  platform: any;
  pickparamsprofile
  pickparamsvariants
  pickparamsURL 
  orderpickparamsprofile; 
  selected        
  showPersonolization;  
  selection; 
  showPersonolizationGreetingfb;
  showem
  showEmojis=false;
  showPersonolizationfB
  @Output() parameter = new EventEmitter();
  @Output() parameterText= new EventEmitter();
  @Output() size = new EventEmitter();
  @Output() personolizationText = new EventEmitter();
  @Output() personolization = new EventEmitter();
  @Output() emoji = new EventEmitter();

  @HostListener('window:scroll', [])
  onScroll(): void { 
    this.showEmojis = false; 
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.cdk-overlay-pane') && 
        !target.closest('.emojistyle') &&
        !target.closest('emoji-mart')) {
      this.showEmojis = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { 
    this.showEmojis = false; 
  }
  public personolized = [
    {'value': this.translate.instant('First Name'), 'viewValue': '${firstName}'},
    {'value': this.translate.instant('Last Name'), 'viewValue': '${lastName}'},
    {'value': this.translate.instant('Bot name'), 'viewValue': '${bot.botName}'},
  
  ]

  public personolizedAlexa = [
    {'value': this.translate.instant('First Name'), 'viewValue': '${firstName}'},
    {'value': this.translate.instant('Last Name'), 'viewValue': '${lastName}'},
    {'value': this.translate.instant('Bot name'), 'viewValue': '${bot.botName}'},
    {'value': this.translate.instant('Voice Assistant'), 'viewValue': '${bot.voiceName}'},
  
  ]

  public personolizedGrettingFacebook = [
    {'value': this.translate.instant('First Name'), 'viewValue': '{{user_first_name}}'},
    {'value': this.translate.instant('Last Name'), 'viewValue': '{{user_last_name}}'},
    {'value': this.translate.instant('full name'), 'viewValue': '{{user_full_name}}'},
  
  ]
  public Parameter = [
    {'value': this.translate.instant('product name'), 'viewValue': '${line_item_name}'},
    {'value': this.translate.instant('happened at'), 'viewValue': '${happened_at}'},
    {'value': this.translate.instant('shipment status'), 'viewValue': '${shipment_status}'},
    {'value': this.translate.instant('tracking company'), 'viewValue': '${tracking_company}'},
    {'value': this.translate.instant('tracking number'), 'viewValue': '${tracking_number}'},
    {'value': this.translate.instant('estimated delivery date'), 'viewValue': '${estimated_delivery_date}'},
    {'value': this.translate.instant('financial status'), 'viewValue': '${financial_status}'},

  ]

  public woocommerceParameter = [
    {'value': this.translate.instant('product name'), 'viewValue': '${line_item_name}'},
    {'value': this.translate.instant('happened at'), 'viewValue': '${happened_at}'},
    {'value': this.translate.instant('financial status'), 'viewValue': '${financial_status}'},

  ]

  public ParameterURL = [
    {'value': this.translate.instant('tracking url'), 'viewValue': '${tracking_url}'},
    {'value': this.translate.instant('order status url'), 'viewValue': '${order_status_url}'},
    {'value': this.translate.instant('map url'), 'viewValue': '${map_url}'},

  ]
  public ParameterProfil = [
    {'value': 'First name', 'viewValue': '${user.firstName}'},
    {'value': 'Last name', 'viewValue': '${user.lastName}'},
    {'value': 'Agent name', 'viewValue': '${bot.botName}'},

  ]

  public ParameterEmailNotifications = [
    {'value': 'First name', 'viewValue': '${user.firstName}'},
    {'value': 'Last name', 'viewValue': '${user.lastName}'},
  ]
  public ParameterEmailNotificationsCancelOrder = [
    {'value': 'First name', 'viewValue': '${user.firstName}'},
    {'value': 'Last name', 'viewValue': '${user.lastName}'},
    {'value': 'orderDateCreation', 'viewValue': '${orderDateCreation}'},
    {'value': 'Amount', 'viewValue': '${amount}'},
    {'value': 'Currency', 'viewValue': '${currency}'},
  ]

  public ParameterEvents = [
    {'value': this.translate.instant('Order name'), 'viewValue': '${orderName}'},
  ]

 constructor(private loggingService: LoggingService, private translate: TranslateService,
  private activatedRoute: ActivatedRoute,
  private router: Router,
  private fb: FormBuilder,
  public snackBar: MatSnackBar,
    private tools:ToolsService,
    private afs: AngularFirestore,
  private auth: AuthService,
  private route: ActivatedRoute,
  private cas: DataAccessService,) {  
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route : any) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    ).subscribe((event) => {
      this.pageInfo = event;
    });
  
  }

  toggleEmojiPicker() {
    this.showEmojis = !this.showEmojis;
  }
  ngOnInit() {
    this.loggingService.log("test orderpickparamsprofile",this.orderpickparamsprofile)
    this.route.parent?.params.subscribe((params)=>{
      this.idBOT = params['id'];
    });
    this.docBot = this.cas.getDocument(`bots/${this.idBOT}`).subscribe(
      b => {
        if (!this.tools.isNullOrUndefined(b)) {
          this.bot = b
          this.platform = b.platform

      }
    }
  );
    this.auth.getUser()?.subscribe(
        u => {
         if (!this.tools.isNullOrUndefined(u)) {
        this.user = u;
        this.docBot = this.cas.getDocument(`bots/${this.idBOT}`).subscribe(
          b => {
            if (!this.tools.isNullOrUndefined(b)) {
              this.bot = b
              this.platform = b.platform

          }
        }
      );
         }
        });
    this.showsize=!this.showsize;
  }
  addParameter(event){
    this.parameter.emit(event.value);
  }
  addParameterText(event){
  this.parameterText.emit(event.value);
  }
  addPersonolized(event,selected=""){
    return this.personolization.emit(event.value);
    // this.selectDropdown.value.reset();
  }
  addPersonolizedText(event,selected=""){
    
    return this.personolization.emit(event.source.value);
    // this.selectDropdown.value.reset();

  }
  showEmoji(){
    this.showEmojis=!this.showEmojis;
  }
  addEmoji(event){
    this.emoji.emit(event.emoji.native);
    this.showEmojis = false;
  }
  ngOnDestroy() {

  }
}